export default {
  overFlowMenu: {
    tooltip: 'Additional functions',
    export: 'Export custom meanings',
    import: 'Import custom meanings',
  },
};
